/*
 * Copyright © 2025 Apple Inc. Adapted for Bowstring from SF Symbols Version 6.0.
 */

import { type Symbol } from "@bowstring/interfaces";


// noinspection JSUnusedGlobalSymbols
export const _ArrowUpAndDownAndArrowLeftAndRight: Symbol = {
  paths:         [
    {
      definition: "M0.477699 18.2198L5.32926 22.6143C6.25504 23.4815 7.49723 22.8135 7.49723 21.6182L7.49723 18.337L15.9699 18.337L15.9699 26.8565L12.6652 26.8565C11.4699 26.8565 10.8019 28.0987 11.6808 29.0245L16.0754 33.876C16.673 34.5323 17.5754 34.4971 18.1496 33.8643L22.5324 29.0245C23.3996 28.0987 22.7316 26.8565 21.5363 26.8565L18.255 26.8565L18.255 18.337L26.7043 18.337L26.7043 21.6182C26.7043 22.8135 27.9464 23.4815 28.8722 22.6143L33.7121 18.2315C34.3566 17.6338 34.3683 16.7432 33.7238 16.1455L28.8722 11.751C27.9464 10.8838 26.7043 11.5518 26.7043 12.7471L26.7043 16.0401L18.255 16.0401L18.255 7.50883L21.5363 7.50883C22.7316 7.50883 23.3996 6.26664 22.5324 5.32914L18.1379 0.477579C17.5519-0.166952 16.6496-0.155233 16.0636 0.489298L11.6808 5.32914C10.8019 6.26664 11.4699 7.50883 12.6652 7.50883L15.9699 7.50883L15.9699 16.0401L7.49723 16.0401L7.49723 12.7471C7.49723 11.5518 6.25504 10.8838 5.32926 11.751L0.489418 16.1338C-0.143395 16.7198-0.178551 17.6104 0.477699 18.2198Z",
      opacity:    0.85,
    },
  ],
  viewBoxHeight: 34.4122,
  viewBoxWidth:  34.5531,
};
